export default __webpack_public_path__ + "static/media/bg-morning.48674865.png";